/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {createSelector} from 'reselect';
import {ApplicationState} from '@/types/redux';

export const selectIsProfileEnabled = ({adminUsers}: ApplicationState) => adminUsers?.isPreInitialized;
export const selectPreInitialized = ({adminUsers: {isPreInitialized}}: ApplicationState) => isPreInitialized;

export const preInitializedSelector =
  createSelector([selectPreInitialized], (isPreInitialized) => (isPreInitialized));
